export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-marker-ae9ebda4bf0852ddc335c1b3c295b89a.svg";